import React, { useState } from 'react';
import './App.css';
import Auth from './Auth';
import BalloonGame from './BalloonGame';

function App() {
  const [showGame, setShowGame] = useState(false);

  const handleStart = () => {
    setShowGame(true);
  };

  const handleBack = () => {
    setShowGame(false);
  };

  return (
    <div className="App">
      {!showGame ? (
        <Auth onLogin={handleStart} />
      ) : (
        <BalloonGame onBack={handleBack} />
      )}
    </div>
  );
}

export default App;
